import React from 'react'
import loading from './loading.svg'

const pageStyle = {
  position: 'fixed',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  inset: 0,
  minHeight: '100vh',
  padding: '24px',
  boxSizing: 'border-box',
  backgroundColor: '#f8f9fe',
}

const cardStyle = {
  width: '100%',
  maxWidth: '480px',
  padding: '40px 32px',
  borderRadius: '18px',
  backgroundColor: '#ffffff',
  boxShadow: '0 24px 60px rgba(50, 50, 93, 0.12)',
  textAlign: 'center',
}

const loadingCardStyle = {
  ...cardStyle,
  minHeight: '320px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}

const loaderStyle = {
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '24px',
}

const errorBadgeStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '72px',
  height: '72px',
  marginBottom: '24px',
  borderRadius: '999px',
  backgroundColor: '#f5365c',
  color: '#ffffff',
  fontSize: '36px',
  fontWeight: 700,
}

const titleStyle = {
  marginBottom: '12px',
  color: '#172b4d',
  fontSize: '28px',
  fontWeight: 700,
}

const messageStyle = {
  marginBottom: '16px',
  color: '#525f7f',
  fontSize: '16px',
  lineHeight: 1.6,
}

const detailsStyle = {
  marginBottom: '24px',
  color: '#8898aa',
  fontSize: '14px',
  lineHeight: 1.5,
}

const actionsStyle = {
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
}

const Callback = ({
  actions = null,
  details = null,
  isLoading = true,
  message = 'Attendi qualche secondo.',
  title = 'Caricamento in corso',
}) => {
  return (
    <div style={pageStyle}>
      <div role={isLoading ? 'status' : 'alert'} aria-live="polite" style={isLoading ? loadingCardStyle : cardStyle}>
        {isLoading ? (
          <div style={loaderStyle}>
            <img src={loading} alt="loading" />
          </div>
        ) : (
          <div aria-hidden="true" style={errorBadgeStyle}>
            !
          </div>
        )}
        <h1 style={titleStyle}>{title}</h1>
        {message ? <p style={messageStyle}>{message}</p> : null}
        {details ? <p style={detailsStyle}>{details}</p> : null}
        {actions ? <div style={actionsStyle}>{actions}</div> : null}
      </div>
    </div>
  )
}

export default Callback
